import { useRef, useState } from "react";
import { ValidationResult } from "sprint-common-web";

import { ContentAssociationDetails } from "../types/ContentAssociationDetails";
import { useAssociateContentState } from "./useAssociateContentState";
import { useAssociateFormContentReferenceMapper } from "./useAssociateFormContentReferenceMapper";

export const useAssociateContentFormFields = () => {
    const [validationResult, setValidationResult] = useState<ValidationResult>();

    const [isFormLoading, setIsFormLoading] = useState<boolean>(false);

    const [contentDetails, setContentDetails] = useState<ContentAssociationDetails | undefined>(undefined);

    const hasLoadedInitialContentRef = useRef(false);

    const { initContentState, setContentState } = useAssociateContentState({
        setContentDetails
    });

    const { mapFormStateToContentReference } = useAssociateFormContentReferenceMapper();

    return {
        mapFormStateToContentReference,
        setContentState,
        isFormLoading,
        setIsFormLoading,
        contentDetails,
        setContentDetails,
        hasLoadedInitialContentRef,
        validationResult,
        setValidationResult,
        initContentState
    };
};
